import { NodeDefinition } from '../../types'
import { NoteEditorNode } from './note.editorNode'
import { NoteIcon } from './note.icon'

export type Config = {
  content: string
  createdByEmail: string
}

export const noteNodeDefinition: NodeDefinition<Config> = {
  name: 'Note',
  editorNode: NoteEditorNode,
  icon: NoteIcon,
  defaultConfig: {
    content: '',
    createdByEmail: ''
  },
  validation: {
    node: { ERROR: [], WARN: [] },
    config: {
      content: { ERROR: [], WARN: [] },
      createdByEmail: { ERROR: [], WARN: [] }
    },
    handles: { ERROR: [], WARN: [] }
  },
  taskTransformer: () => []
}
